import { useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import toast from "react-hot-toast";

import UserMediaSettings from "../../../../components/UserMediaSettings";
import { useGlobal } from "../../../../contexts/globalContext";
import { useMeetingDetailsStore } from "../../../../contexts/meetingDetails/meetingDetailsContext";
import CommentData from "../../../../data/comments";
import { useApi } from "../../../../hooks/useApi";

import { Sidebar } from "./conference-components/sidebar";
import { TopControllerBar } from "./conference-components/top-controller-bar";
import { Popup } from "./popup";

const VideConference = observer(({ onOutsideClick, videoConferanceMode }) => {
  const { inviteParticipant, loadOrgUsers } = useApi();
  const { MEETING_STATE } = useGlobal();

  const { meeting, participants } = useMeetingDetailsStore();
  // const socket = {};
  // const { socket } = useContext(SocketContext);

  const [data] = useState(() => CommentData.getComments());
  // const [activeTab] = useState("participants"); // TODO: ignore for now since we don't have another option
  const [showInactiveParticipants, setShowInactiveParticipants] = useState(false);
  const [emailForInvite, setEmailForInvite] = useState("");
  const [orgUsersList, updateOrgUsersList] = useState([]);

  const getOrgUsers = () => {
    loadOrgUsers()
      .then((res) => {
        updateOrgUsersList(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getOrgUsers();
  }, []);

  const handleInviteClick = () => {
    inviteParticipant(meeting.mid, { email: emailForInvite }).then((res) => {
      if (res.status === "invited") setEmailForInvite("");
      toast(res.msg);
    });
  };

  // useEffect(() => {
  //   publishCommand("S all", socket);
  // }, []);

  return (
    <div className="video-confrance-section" onClick={onOutsideClick}>
      <TopControllerBar />
      <div className="video-confrance-contaner">
        {videoConferanceMode === "camera" ? (
          <div className="video-confrance-main">
            <Popup meetingState={MEETING_STATE} />
            <Sidebar
              showInactiveParticipants={showInactiveParticipants}
              setShowInactiveParticipants={setShowInactiveParticipants}
              emailForInvite={emailForInvite}
              setEmailForInvite={setEmailForInvite}
              participants={participants}
              inactiveParticipants={data}
              handleInviteClick={handleInviteClick}
              orgUsersList={orgUsersList}
            />
          </div>
        ) : (
          <div className="fn__settings-container">
            <UserMediaSettings />
          </div>
        )}
      </div>
    </div>
  );
});

export default VideConference;
